import { Mark } from 'tiptap';

export default class LinkViewer extends Mark {
  options: { openOnClick: boolean };

  constructor(options: { openOnClick: boolean } = { openOnClick: true }) {
    super(options);
    this.options = options;
  }

  get name() {
    return 'link';
  }

  get schema() {
    return {
      attrs: {
        href: {
          default: null,
        },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: dom => ({
            href: dom.getAttribute('href'),
          }),
        },
      ],
      toDOM: node => [
        'a',
        {
          ...node.attrs,
          target: '_blank',
          rel: 'noopener noreferrer nofollow',
        },
        0,
      ],
    };
  }

  get plugins() {
    if (!this.options.openOnClick) {
      return [];
    }
  }
}
